import React from 'react'
import { Link } from 'react-router-dom'

import { useDonationsEmptyStateRecommendations } from '@modules/Dashboard/modules/Recommendations/hooks/useDonationsEmptyStateRecommendations'
import { routing } from '@utils/routing'

import * as EmptyState from '../../../../components/EmptyState/EmptyState'

export const DonationsEmptyState = () => {
  const { recommendations } = useDonationsEmptyStateRecommendations()

  return (
    <EmptyState.Root
      title="You haven’t received any standalone donations yet"
      subtitle={
        <>
          Orders with an added donation are in the{' '}
          <Link to={routing.contributions.orders.all}>orders&nbsp;tab</Link>.
        </>
      }
    >
      {recommendations && recommendations.length > 0 && (
        <EmptyState.Recommendations>
          {recommendations.map(({ suggestion, id }) => {
            return (
              <EmptyState.Suggestion key={`recommendation-${id}`} data-analytics={id}>
                {suggestion}
              </EmptyState.Suggestion>
            )
          })}
        </EmptyState.Recommendations>
      )}
    </EmptyState.Root>
  )
}
